<template>
    <div class="coffee-quiz">
        <coffee-quiz-question
                v-show="answerCount >= 0"
                :page-number="1"
                :num-questions="questionTotal"
                :heading="'Brew Method'"
                :options="filterQuestionsByCategory('brew_method')"
                :tip="'If a roaster recommends a specific brew method for a coffee we will suggest it based on your preferences.'"
                :hide-name="true"
                v-on:answered="onAnswered"
                v-on:deselected="onDeselected"
        />
        <coffee-quiz-question
                v-show="answerCount >= 1"
                :page-number="2"
                :num-questions="questionTotal"
                :heading="'Roast Level'"
                :options="filterQuestionsByCategory('roast')"
                :tip="'This helps us dial in your preferred roast level. We feature hundreds of coffees ranging from very light to very dark.'"
                :hide-name="true"
                v-on:answered="onAnswered"
                v-on:deselected="onDeselected"
        />
        <coffee-quiz-question
                v-show="answerCount >= 2"
                :page-number="3"
                :num-questions="questionTotal"
                :heading="'Adventurousness'"
                :options="filterQuestionsByCategory('adventurousness')"
                :tip="'We\'ll slowly break you out of your comfort zone. You\'ll have a blast expanding your coffee horizons.'"
                :hide-name="true"
                v-on:answered="onAnswered"
                v-on:deselected="onDeselected"
        />
        <coffee-quiz-question
                v-show="answerCount >= 3"
                :page-number="4"
                :num-questions="questionTotal"
                :heading="'Cream & Sugar'"
                :options="filterQuestionsByCategory('cream_and_sugar')"
                :tip="'Some coffees are best enjoyed black but some are designed to handle some cream and sugar. This helps us know which to suggest to you.'"
                :hide-name="true"
                v-on:answered="onAnswered"
                v-on:deselected="onDeselected"
        />
        <coffee-quiz-question
                v-show="answerCount >= 4"
                :page-number="5"
                :num-questions="questionTotal"
                :heading="'Tasting Notes'"
                :options="filterQuestionsByCategory('main_flavor')"
                :tip="'This is not referring to flavor syrups. I repeat, we do not sell flavored coffees! Think of it like tasting notes in wine. Just a way to describe the coffee.'"
                :hide-name="true"
                v-on:answered="onAnswered"
                v-on:deselected="onDeselected"
        />
        <coffee-quiz-question
                v-show="answerCount >= 5"
                :page-number="6"
                :num-questions="questionTotal"
                :heading="'Acidity Level'"
                :options="filterQuestionsByCategory('acidity')"
                :tip="'Acidity is that cut you feel in the back of the roof of your mouth when you taste something tart. This can be beautiful in certain coffees.'"
                :hide-name="true"
                v-on:answered="onAnswered"
                v-on:deselected="onDeselected"
        />
        <coffee-quiz-question
                v-show="answerCount >= 6"
                :page-number="7"
                :num-questions="questionTotal"
                :heading="'Country of Origin'"
                :options="filterQuestionsByCategory('country_of_origin')"
                :tip="'We will initially suggest coffees from the producing countries you select, if you like fruitier or complex coffees we recommend Africans, if you like richer, full bodied coffees we recommend Central and South Americans. If you don’t know or what to try it all, Select All.'"
                :hide-name="true"
                v-on:answered="onAnswered"
                v-on:deselected="onDeselected"
        />
        <coffee-quiz-question
                v-show="answerCount >= 7"
                :page-number="8"
                :num-questions="questionTotal"
                :heading="'Equitable/Sustainable Trade'"
                :options="filterQuestionsByCategory('equitable_trade')"
                :tip="'Crema.co is 100% independent, we only work with 100% independent coffee roasters who put a high value on starting and maintaining Direct relationships with coffee producers at the origin. And are painstakingly transparent about how fairly they are paying for the coffees. Depending on your selection we will suggest just a few, or only coffees that fall in this category'"
                :hide-name="true"
                v-on:answered="onAnswered"
                v-on:deselected="onDeselected"
        />
    </div>
</template>

<script>
    import CoffeeQuizQuestion from '../coffee-quiz/coffee-quiz-question'
    import CoffeeQuizQuestionNested from '../coffee-quiz/coffee-quiz-question-nested'
    import smoothscroll from 'smoothscroll-polyfill';

    const NUM_QUESTIONS = 8;

    export default {
        components: {
            CoffeeQuizQuestion,
            CoffeeQuizQuestionNested
        },
        props: {
            questions: Array,
            questionTotal: Number
        },
        data: function() {
            return  {
                answers: {},
                answerCount: 0,
                prevOption:[]
            }
        },
        methods: {
            filterQuestionsByCategory(category) {
                return this.questions.filter(q => q.category === category)
            },
            onAnswered(option) {
                if (!this.prevOption.includes(option[0].category)){
                    if (option[0].category === 'equitable_trade'){
                        this.answerCount = 8;
                        this.answerCount;
                    }else{
                        this.answerCount++;
                    }
                }
                let optionKeys = [];
                optionKeys.push(option.map((o) => o.key));
                this.scrollToNextQuestion();
                this.answers[option[0].category] = optionKeys.flat();
                this.prevOption.push(option[0].category);
                if (this.answerCount >= NUM_QUESTIONS) {
                    this.$emit('complete', this.answers);
                }
            },
            onDeselected(option) {
                delete this.answers[option.category];
                this.answerCount--;
                this.$emit('deselected');
            },
            scrollToNextQuestion() {
                if (this.answerCount <= NUM_QUESTIONS) {
                    const elem = this.$el.getElementsByClassName('scroll-point')[this.answerCount];
                    setTimeout(() => this.autoScroll(elem), 500);
                }
            },
            autoScroll(elem) {
                if (elem) {
                    elem.scrollIntoView({behavior: 'smooth'});
                }
            }
        },
        watch: {
            answerCount: function () {
                this.$emit('answers-changed', this.answerCount);

                if (this.answerCount >= NUM_QUESTIONS) {
                    this.$emit('complete', this.answers);
                }
            },
        },
        mounted() {
            smoothscroll.polyfill();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/variables_home";
    @import "../../../styles/common_home";

    .coffee-quiz {
        h2 {
            font-size: 28px;
        }
    }
</style>
